import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getAllCrewMaterialTemplates(
  eventId,
  crewMaterialId,
  params = {}
) {
  const parameters = objectToParam(params);
  const response = await axios.get(
    `events/${eventId}/crew-member-materials/${crewMaterialId}/templates?${parameters}`
  );
  return response.data;
}

export async function getCrewMaterialTemplates(eventId, crewMaterialId, id) {
  const { data } = await axios.get(
    `events/${eventId}/crew-member-materials/${crewMaterialId}/templates/${id}`
  );
  return data;
}

export async function createCrewMaterialTemplate(
  eventId,
  crewMaterialId,
  file
) {
  const { data } = await axios.post(
    `events/${eventId}/crew-member-materials/${crewMaterialId}/templates`,
    file
  );
  return data;
}

export async function updateCrewMaterialTemplate(
  eventId,
  crewMemberMaterialId,
  crewMemberMaterialTemplateId,
  values
) {
  const { data } = await axios.put(
    `/events/${eventId}/crew-member-materials/${crewMemberMaterialId}/templates/${crewMemberMaterialTemplateId}`,
    values
  );
  return data;
}

export async function deleteCrewMaterialTemplates(eventId, crewMaterialId, id) {
  const { data } = await axios.delete(
    `events/${eventId}/crew-member-materials/${crewMaterialId}/templates/${id}`
  );
  return data;
}
